module.exports = __webpack_public_path__ + "img/two columns.3dd69e03.svg";